export default __webpack_public_path__ + "static/media/l-instagram.a3bfd9db.svg";